'use strict'

define ['./welcomeModal.scss'], () ->
  ($scope, $rootScope, $uibModalInstance, $cacheFactory, RentappService, $window) ->
    $scope.unit_address = $scope.bundle.applications[0].unit_address
    $scope.shared_by = _.find($scope.bundle.shares, (s) -> s.shared_to.username == $scope.landlord.username).shared_by.username


// WEBPACK FOOTER //
// ./components/dashboard/view/tour/welcome/welcomeModal.coffee